var _rect, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddCompanies(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 89,
    viewBox: "0 0 218 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1476_28099)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 219,
    height: 90,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.032 31.1861L-17.1245 52.7486C-22.5858 53.4406 -26.4608 58.4167 -25.7936 63.8811L-22.7811 88.5547C-22.1867 93.4231 -18.1493 97.1419 -13.2486 97.335L200.999 105.778C204.492 105.916 207.803 104.22 209.732 101.305L237.521 59.3122C241.512 53.2825 237.981 45.1416 230.852 43.934L155.959 31.2472C154.992 31.0833 154.005 31.0627 153.032 31.1861Z",
    fill: "url(#paint0_linear_1476_28099)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1476_28099)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1476_28099",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 81,
    y: 13,
    width: 58,
    height: 68
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.447 80.4931H86.5533C83.4866 80.4931 81 78.0492 81 75.0341V19.0212C81 16.006 83.4866 13.5618 86.5533 13.5618H133.447C136.513 13.5618 139 16.006 139 19.0212V75.0341C139 78.0492 136.513 80.4931 133.447 80.4931Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1476_28099)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.447 80.4931H86.5533C83.4866 80.4931 81 78.0492 81 75.0341V19.0212C81 16.006 83.4866 13.5618 86.5533 13.5618H133.447C136.513 13.5618 139 16.006 139 19.0212V75.0341C139 78.0492 136.513 80.4931 133.447 80.4931Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.238 53.9789H111.833V53.3317H107.238V53.9789Z",
    fill: "#89C0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.8442 62.3924H116.427V60.7744H89.8442V62.3924Z",
    fill: "#89C0FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.8442 70.1586H111.504V68.5406H89.8442V70.1586Z",
    fill: "#89C0FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.8442 66.2756H102.643V64.6576H89.8442V66.2756Z",
    fill: "#89C0FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.0052 48.9672H90.1719V54.3026H95.9109V53.4851H91.0052V48.9672ZM128.393 48.9672V53.4851H123.487V54.3026H129.226V48.9672H128.393ZM90.1724 25.6598H91.0057V21.1428H95.9114V20.3254H90.1724V25.6598ZM123.487 20.3254V21.1428H128.393V25.6598H129.226V20.3254H123.487Z",
    fill: "#89C0FF"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129.5 62C125.909 62 123 64.9093 123 68.5C123 72.0907 125.909 75 129.5 75C133.091 75 136 72.0907 136 68.5C136 64.9093 133.091 62 129.5 62ZM133.274 69.2339C133.274 69.4069 133.133 69.5484 132.96 69.5484H130.548V71.9597C130.548 72.1327 130.407 72.2742 130.234 72.2742H128.766C128.593 72.2742 128.452 72.1327 128.452 71.9597V69.5484H126.04C125.867 69.5484 125.726 69.4069 125.726 69.2339V67.7661C125.726 67.5931 125.867 67.4516 126.04 67.4516H128.452V65.0403C128.452 64.8673 128.593 64.7258 128.766 64.7258H130.234C130.407 64.7258 130.548 64.8673 130.548 65.0403V67.4516H132.96C133.133 67.4516 133.274 67.5931 133.274 67.7661V69.2339Z",
    fill: "#3063E4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.8862 46.9779H121.401V11.2124H97.8862V46.9779Z",
    fill: "#97B1F1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.304 46.9779H121.401V11.2124H110.304V46.9779Z",
    fill: "#648AEB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.906 22.1238H105.02V16.365H102.906V22.1238Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.906 45.1592H105.02V39.4004H102.906V45.1592Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.304 24.397C110.304 24.441 107.524 24.4761 104.096 24.4761C100.666 24.4761 97.8862 24.441 97.8862 24.397C97.8862 24.3537 100.666 24.3182 104.096 24.3182C107.524 24.3182 110.304 24.3537 110.304 24.397Z",
    fill: "#FFFFFE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.906 33.6415H105.02V27.8827H102.906V33.6415Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.304 35.9147C110.304 35.9587 107.524 35.9938 104.096 35.9938C100.666 35.9938 97.8862 35.9587 97.8862 35.9147C97.8862 35.8714 100.666 35.8359 104.096 35.8359C107.524 35.8359 110.304 35.8714 110.304 35.9147Z",
    fill: "#FFFFFE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.683 22.1238H114.796V16.365H112.683V22.1238Z",
    fill: "#97B1F1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.438 22.1238H119.552V16.365H117.438V22.1238Z",
    fill: "#97B1F1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.683 33.3386H114.796V27.5797H112.683V33.3386Z",
    fill: "#97B1F1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.438 33.3386H119.552V27.5797H117.438V33.3386Z",
    fill: "#97B1F1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.683 44.5532H114.796V38.7943H112.683V44.5532Z",
    fill: "#97B1F1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.438 44.5532H119.552V38.7943H117.438V44.5532Z",
    fill: "#97B1F1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.0371 11.2124H123.251V10H96.0371V11.2124Z",
    fill: "#648AEB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1476_28099",
    x: 69,
    y: 5.56177,
    width: 82,
    height: 90.9314,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1476_28099"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1476_28099",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1476_28099",
    x1: -27,
    y1: -73.5081,
    x2: 283.026,
    y2: 41.9154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91D8BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557292,
    stopColor: "#97B1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#F7D780"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1476_28099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 218,
    height: 89,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCompanies);
export default __webpack_public_path__ + "static/media/addCompanies.61e0117de4ce5960ae387fe6132c3b05.svg";
export { ForwardRef as ReactComponent };